import React, { useCallback } from 'react';
import { get, map } from 'lodash/fp';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import CloseIcon from '../../themes/svg/closeIcon';
import ItemDescription from './ItemDescriptionConnector';
import ContainerExpander from './ContainerExpanderConnector';
import { useModalProviderContext } from '../ModalProvider';
import { copyStylesModal } from '../ModalProvider/modalNames';

const CopyStylesModal = ({
  containers, copyStyles, selection, clearSelection, renameWindowLabel,
}) => {
  const { isOpen, setIsOpen, extras } = useModalProviderContext(copyStylesModal);

  const sourceItemId = get('itemId', extras);

  const executeCopyStylesAndWindowLabels = useCallback(() => {
    copyStyles(sourceItemId, selection).then(() => {
      renameWindowLabel(sourceItemId, selection).then(() => {
        setIsOpen(false);
      });
    });
  }, [sourceItemId, selection]);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    clearSelection();
  }, [setIsOpen]);

  if (!isOpen || !sourceItemId) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      className="estimatebuilder-modal"
      overlayClassName="estimatebuilder-modal-overlay"
      style={{
        content: {
          minWidth: 320,
          maxWidth: 800,
          maxHeight: '100vh',
          overflow: 'auto !important',
        },
      }}
    >
      <div className="copyStyleModal">
        <h2>Copy Style</h2>

        <div className="modal-close" onClick={closeModal} tabIndex="-1" role="button">
          <CloseIcon />
        </div>
        <div className="modal-body">
          <ItemDescription itemId={sourceItemId} />
          <span className="instructions">
            Where do you want to copy this style? This will replace any existing style (and all
            options).
          </span>
          <div className="containerList">
            {map(
              containerId => (
                <ContainerExpander
                  sourceItemId={sourceItemId}
                  containerId={containerId}
                  key={`expander-${containerId}`}
                />
              ),
              containers,
            )}
          </div>
          <hr />
          <div className="modal-footer">
            <div className="footer-left">
              <button className="btn btn-secondary footer-btn" onClick={clearSelection}>
                Clear
              </button>
              <span className="selected">{selection.length} window(s) selected</span>{' '}
            </div>
            <div className="footer-right">
              <button
                className="btn btn-primary"
                onClick={executeCopyStylesAndWindowLabels}
                disabled={selection.length === 0}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

CopyStylesModal.propTypes = {
  containers: PropTypes.arrayOf(PropTypes.string).isRequired,
  selection: PropTypes.arrayOf(PropTypes.string).isRequired,
  clearSelection: PropTypes.func.isRequired,
  copyStyles: PropTypes.func.isRequired,
  renameWindowLabel: PropTypes.func.isRequired,
};

CopyStylesModal.defaultProps = {};

export default CopyStylesModal;
